import React, { Component } from 'react'

import Breadcrumbs from '../block/Breadcrumbs'
import Razdel from '../block/Razdel'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <Razdel data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App